import { render, staticRenderFns } from "./CatalogsBaseForm.vue?vue&type=template&id=22ed774c&scoped=true&"
import script from "./CatalogsBaseForm.vue?vue&type=script&lang=js&"
export * from "./CatalogsBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsBaseForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CatalogsBaseForm.vue?vue&type=style&index=1&id=22ed774c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed774c",
  null
  
)

export default component.exports
import {QCard,QCardActions,QItem,QItemSection,QItemLabel,QBtn,QTooltip,QBadge,QBtnDropdown,QCardSection,QInput,QIcon,QScrollArea,QField,QLinearProgress,QInnerLoading,QSpinnerGears,QImg,QMenu,QList,QResponsive,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardActions,QItem,QItemSection,QItemLabel,QBtn,QTooltip,QBadge,QBtnDropdown,QCardSection,QInput,QIcon,QScrollArea,QField,QLinearProgress,QInnerLoading,QSpinnerGears,QImg,QMenu,QList,QResponsive}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
